import Link from 'next/link';
import type React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ButtonClose } from '@/components/buttons';
import { ImageComponent } from '@/components/Image';

import { ScKnowYourLimitModal, ScKnowYourLimitModalWrapper } from './styled';

interface IKnowYourLimitProps {
  onClose?: () => void;
}

export const KnowYourLimitModal: React.FC<IKnowYourLimitProps> = ({
  onClose,
}) => {
  const { t } = useTranslation('common');

  return (
    <ScKnowYourLimitModalWrapper>
      <ScKnowYourLimitModal>
        <ButtonClose gray onClick={onClose} right={1} top={1} />
        <ImageComponent
          alt="responsible-gaming"
          height={80}
          src="/responsible-gaming.png"
          width={80}
        />
        <p className="title">{t('knowYourLimit.title')}</p>
        <p>
          <Trans
            components={{
              1: <Link href="/profile-custom/limits" />,
            }}
            i18nKey="knowYourLimit.description"
          />
        </p>
      </ScKnowYourLimitModal>
    </ScKnowYourLimitModalWrapper>
  );
};
